import * as React from 'react';
import { Button, ModalWindow, UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './index.css';

export interface IModalAlertProps {
  onModalClose(): void;
  isMobile?: boolean;
}

export class ModalAlert extends React.Component<IModalAlertProps> {
  public render() {
    const { onModalClose, isMobile } = this.props;

    const buttonSize = isMobile ? 'M' : 'XS';

    return (
      <ModalWindow width={648} open onClose={onModalClose}>
        <div className={styles['content']}>
          <div className={styles['image']}>&#128588;</div>
          <div className={styles['text']}>
            <div className={styles['heading']}>
              <UIHeading2>Спасибо за заявку!</UIHeading2>
            </div>
            <UIText1 color="gray60_100">Мы свяжемся с вами в ближайшее время</UIText1>
          </div>
          <div className={styles['button']}>
            <Button onClick={onModalClose} size={buttonSize} fullWidth={isMobile}>
              Понятно
            </Button>
          </div>
        </div>
      </ModalWindow>
    );
  }
}
